interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement> {
    marginBottom?: `mb-${number}`;
}

export default function Heading1({ marginBottom = 'mb-3', ...props }: Props) {
    return (
        <h1
            {...props}
            className={(marginBottom + ' text-4xl font-bold')
                .split(' ')
                .concat(props.className?.split(' ') ?? [])
                .join(' ')}
        />
    );
}
